var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGestinCrditos(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 121.67,
    height: 128.999,
    viewBox: "0 0 121.67 128.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_23115",
    "data-name": "Grupo 23115",
    transform: "translate(0.518 0.523)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_23100",
    "data-name": "Grupo 23100"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15672",
    "data-name": "Grupo 15672",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15056",
    "data-name": "Grupo 15056"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Uni\\xF3n_17",
    "data-name": "Uni\\xF3n 17",
    d: "M5.492,77.324H118.142S92.532,107.437,55.7,108.253q-.7.016-1.391.015C18.542,108.268,5.492,77.324,5.492,77.324Zm.189,0S-3.156,65.906,1.213,43.852C3.96,29.98,15.5,23.108,30.972,23.764c5.318.226,13.972-6.5,26.4-14.752,26.594-17.66,65.062-10.16,55.855,29.564-4.455,19.224,14.014,19.532,4.834,38.748Z",
    transform: "translate(0 0)",
    fill: "#d5dced",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    opacity: 0.3
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_23104",
    "data-name": "Grupo 23104",
    transform: "translate(22.704 37.101)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_1792",
    "data-name": "Elipse 1792",
    cx: 20.069,
    cy: 20.069,
    rx: 20.069,
    ry: 20.069,
    transform: "translate(47.062)",
    fill: "#7eccc9",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_23103",
    "data-name": "Grupo 23103",
    transform: "translate(0 16.122)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_86409",
    "data-name": "Rect\\xE1ngulo 86409",
    width: 69.573,
    height: 30.773,
    transform: "translate(2.717 20.541)",
    fill: "#fce3ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_86410",
    "data-name": "Rect\\xE1ngulo 86410",
    width: 69.573,
    height: 8.028,
    transform: "translate(2.717 12.513)",
    fill: "#d1f0ef"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_86411",
    "data-name": "Rect\\xE1ngulo 86411",
    width: 69.573,
    height: 8.028,
    transform: "translate(2.717 3.148)",
    fill: "#7eccc9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_1791",
    "data-name": "Elipse 1791",
    cx: 19.021,
    cy: 19.021,
    rx: 19.021,
    ry: 19.021,
    transform: "translate(18.606 34.728)",
    fill: "#ffc4de"
  }), /*#__PURE__*/React.createElement("g", {
    id: "tarjeta-de-credito_1_",
    "data-name": "tarjeta-de-credito (1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_23099",
    "data-name": "Grupo 23099",
    transform: "translate(15.833 31.666)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_23098",
    "data-name": "Grupo 23098",
    transform: "translate(14.149 8.788)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_23097",
    "data-name": "Grupo 23097",
    transform: "translate(0 2.416)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_108590",
    "data-name": "Trazado 108590",
    d: "M212.031,312.833a10.056,10.056,0,0,1-7.472-3.208,2.2,2.2,0,0,1,3.267-2.961,5.721,5.721,0,0,0,4.2,1.759,2.717,2.717,0,0,0,2.818-1.814c.214-1.2-1.574-1.954-2.126-2.158-2.058-.759-3.958-1.572-4.68-1.887a4.876,4.876,0,0,1-1.31-.828,5.494,5.494,0,0,1-1.672-5.288,6.018,6.018,0,0,1,4.271-4.424c4.634-1.4,8.446,1.748,8.606,1.883a2.2,2.2,0,0,1-2.825,3.385,5.471,5.471,0,0,0-4.509-1.046,1.6,1.6,0,0,0-1.238,1.158,1.067,1.067,0,0,0,.308,1.045.584.584,0,0,0,.131.072c.687.3,2.494,1.073,4.445,1.792,4.291,1.583,5.366,4.69,4.941,7.07A7.02,7.02,0,0,1,212.031,312.833Z",
    transform: "translate(-203.988 -291.669)",
    fill: "#ee2b7c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "L\\xEDnea_9009",
    "data-name": "L\\xEDnea 9009",
    d: "M-12.8-8.322a2.2,2.2,0,0,1-2.2-2.2V-12.8A2.2,2.2,0,0,1-12.8-15a2.2,2.2,0,0,1,2.2,2.2v2.269A2.2,2.2,0,0,1-12.8-8.322Z",
    transform: "translate(20.44 15)",
    fill: "#ee2b7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "L\\xEDnea_9010",
    "data-name": "L\\xEDnea 9010",
    d: "M-12.8-8.322a2.2,2.2,0,0,1-2.2-2.2V-12.8A2.2,2.2,0,0,1-12.8-15a2.2,2.2,0,0,1,2.2,2.2v2.269A2.2,2.2,0,0,1-12.8-8.322Z",
    transform: "translate(20.44 34.317)",
    fill: "#ee2b7c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Elipse_1790",
    "data-name": "Elipse 1790",
    d: "M6.794-15A21.794,21.794,0,1,1-15,6.794,21.819,21.819,0,0,1,6.794-15Zm0,39.179A17.385,17.385,0,1,0-10.591,6.794,17.4,17.4,0,0,0,6.794,24.179Z",
    transform: "translate(15 15)",
    fill: "#3b0310"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_108591",
    "data-name": "Trazado 108591",
    d: "M68.868,53.795H57.128a2.2,2.2,0,1,1,0-4.409h11.74a1.978,1.978,0,0,0,1.976-1.976V6.385a1.978,1.978,0,0,0-1.976-1.976H6.385A1.978,1.978,0,0,0,4.409,6.385V47.409a1.978,1.978,0,0,0,1.976,1.976h11.74a2.2,2.2,0,0,1,0,4.409H6.385A6.393,6.393,0,0,1,0,47.409V6.385A6.393,6.393,0,0,1,6.385,0H68.869a6.393,6.393,0,0,1,6.385,6.385V47.409A6.393,6.393,0,0,1,68.868,53.795Z",
    transform: "translate(0 0)",
    fill: "#3b0310"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_86410-2",
    "data-name": "Rect\\xE1ngulo 86410",
    d: "M-12.8-15H58.049a2.2,2.2,0,0,1,2.2,2.2v8.819a2.2,2.2,0,0,1-2.2,2.2H-12.8a2.2,2.2,0,0,1-2.2-2.2V-12.8A2.2,2.2,0,0,1-12.8-15Zm68.64,4.409H-10.591v4.409H55.844Z",
    transform: "translate(15 23.819)",
    fill: "#3b0310"
  }), /*#__PURE__*/React.createElement("path", {
    id: "L\\xEDnea_9011",
    "data-name": "L\\xEDnea 9011",
    d: "M-.039-10.591H-12.8A2.2,2.2,0,0,1-15-12.8,2.2,2.2,0,0,1-12.8-15H-.039a2.2,2.2,0,0,1,2.2,2.2A2.2,2.2,0,0,1-.039-10.591Z",
    transform: "translate(23.819 41.456)",
    fill: "#3b0310"
  }), /*#__PURE__*/React.createElement("path", {
    id: "L\\xEDnea_9012",
    "data-name": "L\\xEDnea 9012",
    d: "M-.039-10.591H-12.8A2.2,2.2,0,0,1-15-12.8,2.2,2.2,0,0,1-12.8-15H-.039a2.2,2.2,0,0,1,2.2,2.2A2.2,2.2,0,0,1-.039-10.591Z",
    transform: "translate(64.269 41.456)",
    fill: "#3b0310"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGestinCrditos);
export default __webpack_public_path__ + "static/media/Gestión_Créditos.ae5c1c35b8c52df6a677cc8ca05a4bda.svg";
export { ForwardRef as ReactComponent };